import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const QBOIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12.7916 1H11.1913C3.16364 1.56437 -1.57507 10.4991 2.4764 17.5209C6.46895 24.4443 16.3358 24.8938 20.96 18.3707C25.9507 11.3293 21.2316 1.67265 12.7949 1H12.7916ZM11.3942 19.2206C10.8346 19.2206 10.2652 18.9187 9.9968 18.42C9.95098 18.3347 9.7939 17.954 9.7939 17.8851V9.30803H8.08888C6.74058 9.30803 5.60172 10.7944 5.64426 12.0872C5.68353 13.3242 6.80276 14.6958 8.08888 14.6958H8.92994V16.3003C8.20342 16.3233 7.46709 16.2609 6.78312 16.0017C2.56803 14.407 3.324 8.03164 8.33433 7.74289C9.15902 7.69696 10.455 7.60508 11.2535 7.70024C11.3124 7.7068 11.3582 7.7068 11.3942 7.76258V19.2173V19.2206ZM18.8524 14.8598C17.1998 16.7269 14.9711 16.2412 12.7294 16.3003L12.5887 16.238V4.78324C13.1712 4.77011 13.7505 5.11792 14.0188 5.63307C14.0646 5.71839 14.189 6.04323 14.189 6.11869V14.6958H15.894C17.3634 14.6958 18.4728 13.0683 18.3321 11.6771C18.2175 10.5516 17.0558 9.30803 15.894 9.30803H15.0529V7.70352L16.218 7.74946C19.5986 8.21539 21.1465 12.2677 18.8524 14.8598Z",
            fill: "#2CA01D"
        })
    });
};
